module.exports = __webpack_public_path__ + "img/positive.e62304ec.png";